import React, { useState } from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-cream-100 px-6 pb-14 sm:pb-16" aria-labelledby="faq-titulo" data-id="element-49" data-mp="1blka2yumh30n">
      <div className="mx-auto max-w-3xl" data-id="element-50" data-mp="1gitycb69z8mw">
        <h2 id="faq-titulo" className="text-center font-display text-3xl font-bold leading-tight text-forest-800 sm:text-4xl" data-id="element-51" data-mp="1glpubtykbn8p">
          Preguntas Frecuentes
        </h2>

        <ul className="mt-7 grid gap-2.5" data-id="element-52" data-mp="28cvwsh1r9x15">
          {faqs.map(({
          question,
          answer
        }, index) => {
          const isOpen = openIndex === index;
          return <li key={question} className="overflow-hidden rounded-xl border border-cream-300/70 bg-cream-50" data-id="element-53" data-mp="1zh6fok7cbotk" data-mpi={index}>
                <h3 data-id="element-54" data-mp="2n6r25d2pd47l">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 px-5 py-4 text-left font-semibold text-forest-800 transition-colors duration-150 ease-out hover:text-ember-600" data-id="element-55" data-mp="2n67jfu58absi">
                    {question}
                    {isOpen ? <MinusIcon className="h-4 w-4 shrink-0 text-ember-600" aria-hidden="true" data-id="element-56" data-mp="19tc3360842ox" /> : <PlusIcon className="h-4 w-4 shrink-0 text-forest-400" aria-hidden="true" data-id="element-57" data-mp="1ohgctkhat3vk" />}
                  </button>
                </h3>
                <div className={`grid transition-[grid-template-rows] duration-200 ease-out ${isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`} data-id="element-58" data-mp="1xk7sjwh7ilt0">
                  <div className="overflow-hidden" data-id="element-59" data-mp="36q3u652fiwe">
                    <p className="px-5 pb-5 text-sm leading-relaxed text-forest-700/90" data-id="element-60" data-mp="3uchnqns91zar">{answer}</p>
                  </div>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}